import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';
import { ExpertDeliveryRulesSchema } from '../models/expert-delivery-rules.schema';

@Injectable({
  providedIn: 'root'
})
export class ExpertDeliveryRulesService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/expert-delivery-rules`;

  async getAllOperations(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async create(rulesParams: ExpertDeliveryRulesSchema): Promise<ExpertDeliveryRulesSchema> {
    let body = rulesParams;
    return this.request(() => this.http.post<ExpertDeliveryRulesSchema>(`${this.url}`, body).toPromise());
  }

  async updateExpertDeliveryRule(id: number, rulesParams: ExpertDeliveryRulesSchema): Promise<ExpertDeliveryRulesSchema> {
    let body = rulesParams;
    return this.request(() => this.http.put<ExpertDeliveryRulesSchema>(`${this.url}/${id}`, body).toPromise());
  }

  async getOne(id: number): Promise<ExpertDeliveryRulesSchema> {
    return this.request(() => this.http.get<ExpertDeliveryRulesSchema>(`${this.url}/${id}`).toPromise());
  }

  async delete(id: number): Promise<{ id: number, success: boolean }> {
    return this.request(() => this.http.delete<{ id: number, success: boolean }>(`${this.url}/${id}`).toPromise());
  }

  async getOneExpertDeliveryRuleWithExpert(expertId: number): Promise<ExpertDeliveryRulesSchema> {
    return this.request(() => this.http.get<ExpertDeliveryRulesSchema>(`${this.url}/expert/${expertId}`).toPromise());
  }

  async getAssociateExpertDeliveryRule(expertId: number): Promise<any> {
    return this.request(() => this.http.get<ExpertDeliveryRulesSchema>(`${this.url}/associate/expert/${expertId}`).toPromise());
  }
}
